import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const FinanceView = angular
  .module('acme.view.application.finance', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.finance.controllers',
    'acme.view.application.finance.list',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const finance = {
      name: 'application.finance',
      url: '/finance',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'FinanceController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/finance/finance.tpl.html',
        },
      },
      data: {
        pageTitle: 'Finance',
        permissions: ['FINANCE_REPORTS_VIEW'],
      },
    };

    $stateProvider.state(finance);
  }).name;
